import { useNavigate } from "react-router-dom";
import { FaPlus } from "react-icons/fa";
import { useEffect, useState } from "react";
import { VscFilter } from "react-icons/vsc";
import { getCourseApi } from "../../../Api/Course";
import toast from "react-hot-toast";
import { IconTrash } from "@tabler/icons-react";
import {
    deleteCourseOfferingApi,
    getCourseOfferingByPaginationApi
} from "../../../Api/CourseOffering";
import { getCourseTypeApi } from "../../../Api/CourseType";
import React from "react";
import DeleteItem from "../DeleteItem";
import { TbFilterX } from "react-icons/tb";
import { CourseForm } from "./CourseForm";
import CourseOfferingForm from "./CourseOfferingForm";
import SideModal from "../../general/Sidemodal";

interface Props {
    url: string;
}

export function CourseOffering({ url }: Props) {
    interface courseOfferingType {
        id: string;
        name: string;
        type: string;
        fees: number;
        timings: [
            {
                id: string,
                courseTypeId: string,
                startTime: string,
                endtime: string
            }
        ]
    }

    const [courseOffering, setcourseOffering] = useState<courseOfferingType[]>([]);
    const [CourseTypes, setCourseTypes] = useState<{ id: string; name: string }[]>([]);
    const [selectedCourseType, setSelectedCourseType] = useState<string>("");
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [filterModal, setFilterModal] = useState(false);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    const [expandedRows, setExpandedRows] = useState<string[]>([]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState<{ id: string } | null>(null);

    const navigate = useNavigate();

    const [showFormModal, setShowFormModal] = useState(false);
    const [editId, setEditId] = useState<string | null>(null);

    const handleAddClick = () => {
        setEditId(null);
        setShowFormModal(true);
    };

    const handleEditClick = (id: string) => {
        setEditId(id);
        setShowFormModal(true);
    };


    const handleDeleteClick = (id: string) => {
        setSelectedItem({ id });
        setIsModalOpen(true);
    };


    const confirmDelete = async () => {
        if (!selectedItem) return;

        try {
            await deleteCourseOfferingApi(selectedItem.id, url);
            handleApiCallClick(currentPage);
            toast.success("Deleted successfully!");
        } catch (error) {
            toast.error("Failed to delete." + error);
        } finally {
            setIsModalOpen(false);
            setSelectedItem(null);
        }
    };

    const handleApiCallClick = async (currentPage) => {
        try {
            const courseOfferingData: any = await getCourseOfferingByPaginationApi(url, currentPage, itemsPerPage, selectedCourseType, searchTerm);
            const totalCount = courseOfferingData.totalCount || 0;
            setTotalPages(Math.ceil(totalCount / itemsPerPage));
            const courseTypeData: any = await getCourseTypeApi(url);
            const courseData: any = await getCourseApi(url);

            const courseTypeOptions = courseTypeData.map((courseType: any) => ({
                id: courseType.id,
                name: courseType.name,
            }));
            setCourseTypes(courseTypeOptions);


            // Combine data
            const combinedData = courseOfferingData.courseOffering.map((item: any) => {

                const course = courseData.find((c: any) => c.id === item.courseId);
                const courseType = courseTypeData.find(
                    (ct: any) => ct.id === item.courseTypeId
                );

                // If item.fees is 0 or falsy, use courseType.fees
                // console.log(item, 'datttttaaaaaa', courseType);

                let fees = item.fees;
                if (!fees && courseType?.fees) {
                    fees = courseType.fees;
                }
                let timings = item.timings;

                if (Array.isArray(timings) && timings.length === 0 && courseType?.timings) {
                    timings = courseType.timings;
                }

                // Return combined object, handle undefined gracefully
                return {
                    ...item,
                    name: course?.name || "Unknown Course",
                    type: courseType?.name || "Unknown Type",
                    fees,
                    timings,
                };
            });


            setcourseOffering(combinedData);
        } catch (error) {
            toast.error("Failed to fetch course data. Please try again.")
            console.error(error);
        }
    };

    useEffect(() => {
        handleApiCallClick(currentPage);
    }, [currentPage, showFormModal]);

    const handleTypeChange = (e) => {
        setSelectedCourseType(e.target.value);
    }

    // Search functions
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.preventDefault();
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
    };

    const handleSearchSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setCurrentPage(1);
        handleApiCallClick(currentPage);
    };

    const handleNextPage = () => {
        setCurrentPage((prevPage) => {
            if (prevPage < totalPages) {
                return prevPage + 1;
            }
            return prevPage;
        });
    };

    const clearAllFilters = () => {
        setSelectedCourseType("")
    }

    const applyFilters = () => {
        setFilterModal(false);
        setCurrentPage(1);
        handleApiCallClick(currentPage);
    }

    const toggleRowExpansion = (courseOfferingId: string) => {
        setExpandedRows((prevExpandedRows) =>
            prevExpandedRows.includes(courseOfferingId)
                ? prevExpandedRows.filter((id) => id !== courseOfferingId)
                : [...prevExpandedRows, courseOfferingId]
        );
    };

    return (
        <div className="px-2 md:px-4 mt-6">

            <div className='flex flex-row items-center '>
                <h2 className="text-3xl font-bold text-blue-600 mb-5">Course Offering</h2>
                <button
                    type="button"
                    className=" w-fit px-3 py-2 mx-3 mb-4 tracking-wide text-white capitalize transition-colors duration-300 transform bg-blue-600 rounded-lg hover:bg-blue-500 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-80"
                     onClick={handleAddClick}
                >
                    <FaPlus className="w-3 h-3" />
                </button>
            </div>

            <div className="flex flex-row items-center w-full gap-4 justify-between md:justify-start">
                <form onSubmit={handleSearchSubmit} className="w-full md:flex-grow">
                    <label
                        htmlFor="default-search"
                        className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                    >
                        Search
                    </label>
                    <div className="relative">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                            <svg
                                className="w-4 h-4 text-gray-500 dark:text-gray-400"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    stroke="currentColor"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                                />
                            </svg>
                        </div>
                        <input
                            type="search"
                            id="default-search"
                            className="w-full p-3 ps-10 outline-none text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Search by Name, Email, Mobile, Course name"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            required
                        />
                        <button
                            type="submit"
                            className="text-white absolute end-1.5 bottom-1.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                        >
                            Search
                        </button>
                    </div>
                </form>
                <div
                    className="flex flex-row gap-1 justify-center px-1 py-2 h-10 w-[90px] hover:bg-gray-100 rounded-md cursor-pointer"
                    onClick={() => setFilterModal(true)}
                >
                    <VscFilter className="text-blue-500 h-7 w-7" />
                    <span className="text-lg font-normal text-gray-600">Filter</span>
                </div>
            </div>

            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-700 md:rounded-lg">
                    <thead className="bg-gray-50 dark:bg-gray-800">
                        <tr>
                            <th
                                scope="col"
                                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                            >
                                Action
                            </th>
                            <th
                                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                            >
                                Course Name
                            </th>
                            <th
                                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                            >
                                Course Type
                            </th>
                            <th
                                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                            >
                                Fees
                            </th>
                            <th
                                className="px-4 py-3.5 text-md font-normal text-left rtl:text-right text-gray-500 dark:text-gray-400"
                            >
                                Timings
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200 dark:divide-gray-700 dark:bg-gray-900">
                        {courseOffering.map((item) => {
                            // console.log(courseOffering,'courseoffeeing');

                            return (
                                <React.Fragment key={item.id}>
                                    <tr key={item.id} className="hover:bg-gray-50">
                                        <td className="px-4 py-4 text-sm whitespace-nowrap">
                                            <div className="flex items-center gap-x-3">
                                                <IconTrash
                                                    className="cursor-pointer text-gray-500 transition-colors duration-200 hover:text-red-500"
                                                    onClick={() => handleDeleteClick(item.id)}
                                                />
                                                <button
                                                    onClick={() => handleEditClick(item.id)}
                                                    className="text-gray-500 transition-colors duration-200 dark:hover:text-yellow-500 dark:text-gray-300 hover:text-yellow-500 focus:outline-none"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth="1.5"
                                                        stroke="currentColor"
                                                        className="w-5 h-5"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
                                                        />
                                                    </svg>
                                                </button>
                                            </div>
                                        </td>
                                        <td className="px-4 py-4 text-sm font- text-gray-700 whitespace-nowrap">
                                            {item.name}
                                        </td>
                                        <td className="px-4 py-4 text-sm font- text-gray-700 whitespace-nowrap">
                                            {item.type}
                                        </td>
                                        <td className="px-4 py-4 text-sm font- text-gray-700 whitespace-nowrap">
                                            {item.fees}
                                        </td>
                                        <td className="px-4 py-4 text-sm font- text-gray-700 whitespace-nowrap">
                                            <div className="flex justify-between items-center">
                                                <span>{item.timings && item.timings.length > 0 ? (
                                                    <button
                                                        className="text-blue-600 hover:underline"
                                                        onClick={() => toggleRowExpansion(item.id)}
                                                    >
                                                        {expandedRows.includes(item.id) ? 'Hide' : 'Show'}
                                                    </button>
                                                ) : (
                                                    <div>Not available</div>
                                                )}</span>
                                            </div>
                                        </td>
                                    </tr>
                                    {expandedRows.includes(item.id) && (
                                        <tr>
                                            <td colSpan={5} className="px-4 py-2">
                                                <div>
                                                    <table className="w-full border-collapse border border-gray-200">
                                                        <thead className="bg-gray-200">
                                                            <tr>
                                                                <th className="font-normal px-4 py-2 text-center text-gray-500">Start Time</th>
                                                                <th className="font-normal px-4 py-2 text-center text-gray-500">End Time</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {item.timings.map((avail, availIndex) => (
                                                                <tr key={availIndex} className="hover:bg-gray-50">
                                                                    <td className="border border-gray-300 px-4 py-2 text-center text-gray-500">
                                                                        {avail.startTime}
                                                                    </td>
                                                                    <td className="border border-gray-300 px-4 py-2 text-center text-gray-500">
                                                                        {avail.endtime}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>


                            )
                        })}
                    </tbody>
                </table>
            </div>


            {isModalOpen && (
                <DeleteItem onClose={() => setIsModalOpen(false)} onConfirm={confirmDelete} />
            )}


            {/* Pagination */}
            <div className="flex flex-wrap items-center justify-center md:justify-between mt-6 gap-2 md:gap-4">
                {/* Previous Button */}
                <button
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                    className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-5 h-5 rtl:-scale-x-100"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                        />
                    </svg>
                    <span>Previous</span>
                </button>

                <div className="flex flex-wrap items-center justify-center gap-x-2">
                    {/* Page Number */}

                    {[...Array(totalPages)].map((_, index) => (
                        <button
                            key={index + 1}
                            onClick={() => setCurrentPage(index + 1)}
                            className={`px-2 py-1 text-sm ${currentPage === index + 1
                                ? "text-blue-500 bg-blue-100"
                                : "text-gray-500 hover:bg-gray-100"
                                } rounded-md`}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div>

                {/* NEXT Button */}
                <button
                    // disabled={currentPage === totalPages}
                    // onClick={() => setCurrentPage(currentPage + 1)}
                    onClick={handleNextPage}
                    className="flex items-center px-5 py-2 text-sm text-gray-700 capitalize transition-colors duration-200 bg-white border rounded-md gap-x-2 hover:bg-gray-100 dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800"
                >
                    <span>Next</span>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-5 h-5 rtl:-scale-x-100"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                        />
                    </svg>
                </button>
            </div>

            {/* filter Modal */}
            <div className="inset-0 bg-gray-800 bg-opacity-50 z-50 transition-opacity duration-300">
                <div
                    className={`fixed top-0 right-0 h-full w-[500px] md:w-[500px] bg-white p-4 rounded-md shadow-lg transform transition-transform duration-500 ease-in-out ${filterModal ? "translate-x-0" : "translate-x-full"
                        }`}
                >
                    <h1 className="text-2xl md:text-3xl font-bold text-blue-600 mb-4 md:mb-6">
                        Filter
                    </h1>
                    <button
                        onClick={() => setFilterModal(false)}
                        className="absolute top-1 right-3 text-gray-400 hover:text-gray-600 text-2xl"
                    >
                        &times;
                    </button>

                    <div className="  flex items-center gap-4 my-4">
                        <div
                            onClick={clearAllFilters}
                            className=" cursor-pointer flex items-center gap-2 hover:bg-gray-200 py-1 rounded-sm"
                        >
                            <TbFilterX className="text-blue-500 h-5 w-5" />
                            <span className="text-sm">Clear all</span>
                        </div>
                    </div>

                    <div className="flex flex-col gap-3">

                        <div className="flex flex-col">
                            <div className="mb-4 flex flex-col">
                                <label className="text-base font-semibold text-gray-900 mb-2">Course Type</label>
                                <div className="w-full">
                                    <select
                                        value={selectedCourseType}
                                        onChange={handleTypeChange}
                                        required
                                        className="w-[96%] px-4 py-2 text-gray-800 bg-white border border-gray-400 rounded-md dark:bg-gray-800 dark:text-gray-300 dark:border-gray-800 focus:border-blue-400 focus:ring-blue-300 focus:ring-opacity-40 dark:focus:border-blue-300 focus:outline-none focus:ring"
                                    >
                                        <option value="">All</option>
                                        {CourseTypes.map((courseType: { id: string; name: string }) => (
                                            <option key={courseType.id} value={courseType.id}>
                                                {courseType.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div className=" flex gap-2 md:gap-4 mt-5">
                        <button
                            onClick={applyFilters}
                            className="mt-2 px-4 py-1 text-white border border-gray-800 rounded-sm bg-blue-600 hover:bg-blue-700"
                        >
                            Apply
                        </button>
                        <button
                            className="mt-2 px-4 py-1 border border-gray-800  rounded-sm hover:bg-gray-200"
                            onClick={() => setFilterModal(false)}
                        >
                            Cancel
                        </button>
                    </div>

                </div>
            </div>


            <SideModal isOpen={showFormModal} onClose={() => setShowFormModal(false)}>
                <CourseOfferingForm
                    url={url}
                    courseId={editId}
                    onClose={() => setShowFormModal(false)}
                />
            </SideModal>

        </div>
    );
}

export default CourseOffering;
